<script>
// Renders a shell icon from the active theme's icon library (Lucide / Tabler /
// Phosphor). Accepts a semantic key ("receipt") or an existing mdi-* name; any
// name without a mapping falls back to the normal <v-icon>.
import { ICON_SETS, MDI_TO_KEY } from "@/ui-theme/icons";
import { UI_THEMES } from "@/ui-theme/themes";
import { VIcon } from "vuetify/lib";

const SET_ATTRS = {
  lucide: {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.75",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
  },
  tabler: {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
  },
  phosphor: { viewBox: "0 0 256 256", fill: "currentColor" },
};

export default {
  name: "UiIcon",
  props: {
    name: { type: String, required: true },
    size: { type: [Number, String], default: 20 },
  },
  computed: {
    iconSet() {
      const theme = UI_THEMES[this.$store.state.uiTheme];
      return theme ? theme.iconSet : "lucide";
    },
    svgInner() {
      const key = MDI_TO_KEY[this.name] || this.name;
      const set = ICON_SETS[this.iconSet] || {};
      return set[key] || null;
    },
  },
  render(h) {
    if (!this.svgInner) {
      return h(VIcon, { props: { size: this.size } }, this.name);
    }
    return h("svg", {
      class: ["ui-icon", `ui-icon--${this.iconSet}`],
      attrs: {
        ...SET_ATTRS[this.iconSet],
        width: this.size,
        height: this.size,
        "aria-hidden": "true",
        focusable: "false",
      },
      domProps: { innerHTML: this.svgInner },
    });
  },
};
</script>

<style lang="scss">
.ui-icon {
  display: inline-block;
  flex: none;
  vertical-align: middle;
}
</style>
